import { render, staticRenderFns } from "./BimCompareSidebar.vue?vue&type=template&id=2d91e09e&scoped=true"
import script from "./BimCompareSidebar.vue?vue&type=script&lang=js"
export * from "./BimCompareSidebar.vue?vue&type=script&lang=js"
import style0 from "./BimCompareSidebar.vue?vue&type=style&index=0&id=2d91e09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91e09e",
  null
  
)

export default component.exports